// extracted by mini-css-extract-plugin
export default {"menuItem":"MobileMenuButton-module__menuItem_AMs83","iconCircle":"MobileMenuButton-module__iconCircle_WoVTz"};